<template>
	<div>
		<header class="lmy-header lmy-header-w">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        账户流水
	    </header>
	    <ul class="lmy-order-menu">
	        <li :class="isActive?'item active':'item'" @click="isActive=true;"><span>入账记录</span></li>
	        <li :class="!isActive?'item active':'item'" @click="isActive=false;"><span>提现记录</span></li>
	    </ul>
	    <div class="lmy-account-detail" v-if="isActive">
	        <!-- <div class="title">08月</div> -->
	        <div class="account-list" >
	            <div class="list-item" v-for="item in Info.Items">
	                <div class="list-title">{{item.HotelName}} <span>+{{item.Amount}}.00</span></div>
	                <div class="no">{{item.OrderNO}} <span>{{item.CreateDate|dateLong}} </span></div>
	            </div>
	        </div>
	           <div v-if="!Info.Items||Info.Items.length<=0" class="text-center">
	            	<label>您暂时没有任何入帐记录！</label>
	            </div>
	    </div>
	    <div class="lmy-account-detail" v-if="!isActive">
	        <!-- <div class="title">08月</div> -->
	        <div class="account-list">
	            <div class="list-item" v-for="item in list">
	                <div class="list-title">{{item.PaymentNO||'无'}}<span class="sub">-{{item.Amount}}.00</span></div>
	                <div class="no">{{item.ReceiverName}}  <span>{{item.WithdrawTime|dateLong}} </span></div>
	            </div>
	        </div>
	            <div v-if="!list||list.length<=0" class="text-center">
	            	<label>您暂时没有任何提现记录！</label>
	            </div>
	    </div>

	</div>

</template>
<script>
	export default{
		name:'payment',
		data(){
			return{
				Info:JSON.parse(this.dao.get('UserWithdrawInfo')),
				list:'',
				isActive:true
			}
		},
		methods:{
			initData(){
 		 		var that=this;
 		 		var param={
					Page:0,
					PageSize:0,
					WithdrawID:'',
				}

				that.postRequest({
					url:that.Api.getWithdraws,
					params:param
				}).then(res => {
					if (res&&res.IsSuccess) {
				        that.list =res.Result;
				    }
				});
 		 	}
		},
		mounted(){

			this.initData();
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/usr/withdraw/payment.vue